<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.material.add')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <!-- <li class="breadcrumb-item"><router-link to="/master"><span>{{$t('tlt.master')}}</span></router-link></li> -->
                    <li class="breadcrumb-item"><router-link to="/master/material"><span>{{$t('tlt.material')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/master/material/edit"><span>{{$t('tlt.material.new')}}</span></router-link></li>
                </ul>
            </div>
            <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFbackToList('material')"><i class="fa fa-fw fa-lg fa-minus-circle"></i><span class=text>{{$t('btn.basic.cancel')}}</span></button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFSave('material')"><i class="fa fa-fw fa-lg fa-save"></i><span class=text>{{$t('btn.basic.save')}}</span></button>
                </div>
            </div>
        </div>
        <section class="app-content">
            <form>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("tlt.material.matCode") }}:</label>
                                <input class="form-control form-control-sm" v-model="matCode" type="text" >
                            </div>
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("tlt.material.matName") }}:</label>
                                <input class="form-control form-control-sm" v-model="matName" type="text" >
                            </div>
                            <!-- <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg"></span>{{ $t("tlt.material.matDesc") }}:</label>
                                <input class="form-control form-control-sm" v-model="matDesc" type="text" >
                            </div> -->
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("tlt.material.type") }}:</label>
                                <select class="form-control form-control-sm" 
                                
                                @click.native.stop @change="disableHierarchy" v-model="matType">
                                        <option value="">选择</option>
                                        <option value="B">{{ $t("lbl.basic.rawMaterial") }}</option>
                                        <option value="B">{{ $t("lbl.basic.rawMaterial") }}</option>
                                        <!-- <option value="E">{{ $t("lbl.basic.energy") }}</option> -->
                                </select>
                            </div>
                             
                             <div class="form-group col-md-3">
                                <label class="control-label">{{ $t("lbl.material.matModel") }}</label>
                                <input class="form-control form-control-sm" v-model="matModel" type="text"> 
                             </div> 
                                 <div class="form-group col-md-3">
                                <label class="control-label">{{ $t("lbl.material.matSpec") }}</label>
                                <input class="form-control form-control-sm" v-model="matSpec" type="text"> 
                                 </div>                    
                            <div class="form-group col-md-3">
                                <label class="control-label"><span class="lbl-obg">*</span>{{ $t("lbl.material.unit") }}</label>
                                <input class="form-control form-control-sm" v-model="matUnit" type="text">
                        </div> 
                         </div> 
                    </div>
                </div>
            </form>
        </section>
    </div>
 </template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapActions, mapState } from "vuex";
// import {fields}  from "@/model/Material";
import {fields}  from "@/model/master/Material";

const { mapFields } = createHelpers({
  getterType: 'material/getField',
  mutationType: 'material/updateField',
});
export default {
  data () {
    return {
      materialTypeDisabled: true,
      materialNameDisabled: true,
      matTypeDisable:true,
      typeDisabled:true
    }
  },
  computed: {
    ...mapFields(fields),
    ...mapState({
        materialTypeCBO: state => state.material.materialTypeCBO,
        materialNameCBO: state => state.material.materialNamerCBO,
    })
  },
  mounted(){
     //this.MMFCheckState('location'); 
     this.typeDisabled = (this.$store.state.material.crudState == 'edit');
      if( !this.typeDisabled){
          this.disableHierarchy();
      }
  },
  methods: {
    ...mapActions("material", ["loadmaterialType", "selectParentMaterial"]),
    ...mapActions("base", ["MMFbackToList", "MMFSave", "MMFCheckState"]),
    disableHierarchy(){
        this.matTypeDisabled= true;
        this.materialNameDisabled = true;
        this.typeDisabled=true;

        this.$store.commit("material/setMaterialNameCBO", []);
        this.$store.commit("material/setMaterialTypeCBO", []);

        var enty1 = JSON.parse(JSON.stringify(this.$store.state.material.entity));
        enty1.materialType = "";
        enty1.materialName = "";


        this.$store.commit("material/setEntity", enty1);

        switch (this.$store.state.material.entity.matType) {
            case 'N':
                this.materialTypeDisabled= false;    
            break;
            // case 'N':
            //     this.materialTypeDisabled= false;
            //    c
            // break;
        }
        this.$store.dispatch('material/loadMaterialByType', {type: 'T', idMaterial : 0} );
    }
  }
};
</script>